"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLengthUnit = void 0;
const react_1 = require("react");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const react_router_dom_1 = require("react-router-dom");
const useBrowserLocale_1 = require("./useBrowserLocale");
const length_1 = require("../utils/length");
const usePersistedState = use_persisted_state_1.default('default-length-unit');
function useLengthUnit() {
    var _a;
    const locale = useBrowserLocale_1.useBrowserLocale();
    const [unit, setUnit] = usePersistedState(defaultLengthUnit(locale));
    const location = react_router_dom_1.useLocation();
    const urlUnitString = new URLSearchParams((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : '').get('lengthUnit');
    const urlUnit = urlUnitString && Number(urlUnitString) in length_1.LengthUnit ? Number(urlUnitString) : null;
    const data = urlUnit !== null && urlUnit !== void 0 ? urlUnit : Number(unit);
    return react_1.useMemo(() => [data, setUnit], [data, setUnit]);
}
exports.useLengthUnit = useLengthUnit;
const defaultLengthUnit = (locale) => {
    switch (locale) {
        case 'en-US':
            return length_1.LengthUnit.foot;
    }
    return length_1.LengthUnit.meter;
};
exports.default = useLengthUnit;
//# sourceMappingURL=useLengthUnit.js.map